import { useRouter } from 'next/router';
import type { NextSeoProps } from 'next-seo';
import { NextSeo } from 'next-seo';
import type { Seo as SeoType } from 'types/cms/Seo';
import { getPageUrl } from 'utils/getBaseUrl';

import { getOpenGraphImage } from './getOpenGraphImage';

interface SeoProps extends NextSeoProps {
  seo: SeoType;
}

const OG_IMAGE_WIDTH = 1200;
const OG_IMAGE_HEIGHT = 630;

export function Seo({ seo, noindex, nofollow, openGraph, ...rest }: SeoProps) {
  const router = useRouter();

  if (!seo) {
    return null;
  }

  const image = seo.image
    ? getOpenGraphImage(seo.image, OG_IMAGE_WIDTH, OG_IMAGE_HEIGHT)
    : undefined;

  return (
    <NextSeo
      noindex={noindex}
      nofollow={nofollow}
      title={seo.title}
      description={seo.description}
      canonical={getPageUrl(router.asPath)}
      openGraph={{
        title: seo.title,
        description: seo.description,
        url: getPageUrl(router.asPath),
        images: image
          ? [
              {
                url: image,
                width: OG_IMAGE_WIDTH,
                height: OG_IMAGE_HEIGHT,
              },
            ]
          : undefined,
        ...openGraph,
      }}
      {...rest}
    />
  );
}
